import React, { forwardRef } from 'react';

import { emojiSuggestion, colorBlue10 } from "./styles/MentionSuggestions.module.scss";

// backgroundColor can't be added as classname otherwise it messes with focusing

// this needs to be a function for forwardRef, and therefore cannot have propTypes
// eslint-disable-next-line react/prop-types
function EmojiMentionSuggestion({ id, display, focused }, ref) {
  return (
    <div
      ref={ref}
      className={emojiSuggestion}
      style={{ backgroundColor: focused ? colorBlue10 : "white" }}
    >
      <span className="pr-2">
        {display}
      </span>
      {id}
    </div>
  );
}
// eslint-enable-next-line react/prop-types

export default forwardRef(EmojiMentionSuggestion);
